export const SET_CREDIT_LIMIT = 'CREDIT_LIMIT/SET_CREDIT_LIMIT';
